import Backbone from "backbone";
import Form from "./auth/FormValidator"
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";

    /**
     * Address Form management 
     */
export default Backbone.View.extend({

        qasPopin: undefined,

        selectors: {
            form: ".js-addresses-form",

            inputAddress: ".js-input-address",
            inputPostalCode: ".js-input-postalCode",
            inputCity: ".js-input-city",
            formContainer: '.js-form-content',
            particularContainer: '.js-particular',
            professionalContainer: '.js-professional',
            documentContainer: '.js-document-container',
            inputElement: '.js-form-input',
            qasContainer: '.js-qas-popin-container',
            disabledDocument: '.js-disabledDocument',
            fiscalTaxNumber: '.js-fiscal-number-type',
            selectCountry: '.js-select-country',
            selectDocumentCountry:'.js-select-document-country',
            stateDisplay: '.js-state-display',
            selectState: '.js-state-status',
            errorState: '.js-state-error'
        },

        events: {
            //"submit": "onSubmit",
            "click .js-clientType-choice": "onDisplayClientType",
            "change .js-document-type": "onClientTypeChange",
            "keyup .js-form-input-company": "onCompanyChanged",
            "change .js-select-country": "onCountryChanged",
            "change .js-select-document-country": "onDocumentCountryChanged",
            "keyup .js-disabledDocument .js-form-input": "onBlurDocument"
        },

        initialize: function () {
            this.validator = new Form({ target: this.selectors.form });
            this.hideStateField();

            this.initializeActiveClientType();
            this.onBlurDocument();
            this.onDocumentCountryChanged();
            this.listenTo(SharedDispatcher, "addressesform:submit", this.onCountryChanged);

            $("input[name='FiscalTaxNumber']").blur();

        },

        initializeActiveClientType: function () {
            $(this.selectors.disabledDocument).not('.active').find('.js-form-input').prop('disabled', true);

            if ($(this.selectors.professionalContainer).hasClass('active')) {
                this.onDocumentAttribution();
                $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', true);
                $(this.selectors.fiscalTaxNumber).prop('disabled', false);
            }
            else {
                this.renderClientTypeChange();
                $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', false);
                $(this.selectors.fiscalTaxNumber).prop('disabled', true);
            }
        },

        toggleDisplayClient: function (elementType) {

            var clientSelection = elementType.attr("data-client-type");

            if (elementType.is(':checked')) {
                $(this.selectors.formContainer).removeClass('active').hide();
                $(this.selectors.formContainer).find('.js-form-input').val('').prop('disabled', true);
                $('.' + clientSelection).find('.js-form-input').prop('disabled', false);
                $('.' + clientSelection).removeClass('hidden').show();

                if (clientSelection == "js-professional") {
                    this.onDocumentAttribution();
                    $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', true);
                    $(this.selectors.fiscalTaxNumber).prop('disabled', false);
                    $('.js-company-name-field').removeClass('hide');
                }
                else {
                    this.renderClientTypeChange();
                    $(this.selectors.disabledDocument).find('.js-form-select').prop('disabled', false);
                    $(this.selectors.fiscalTaxNumber).prop('disabled', true);
                    $('.js-company-name-field').addClass('hide');
                }
            }

            this.onDocumentCountryChanged();
        },

        renderClientTypeChange: function () {

            var optionDocument = $(this.selectors.particularContainer).find('.js-document-type option:selected'),
                optionDocumentReg = optionDocument.attr('data-regex'),
                labelDocument = $(this.selectors.particularContainer).find('.js-document-label'),
                inputDocument = $(this.selectors.particularContainer).find('.js-form-input');

            labelDocument.text(optionDocument.text());
            $(this.selectors.documentContainer).removeClass('hidden');
           
            inputDocument.rules("add", { regex: "^" + optionDocumentReg })
            inputDocument.focus();
        },

        onCompanyChanged: function (e) {
            e.preventDefault();
            $('.js-form-input-fax-display').toggleClass('hide', $(e.currentTarget).val() === '');
        },

        onCountryChanged: function () {
            // Display state field (Provincia) if country is España (Península)
            if ($(this.selectors.selectState) && $(this.selectors.selectCountry).find(":selected").val() === "197") {
                $(this.selectors.selectState).attr("disabled", false);
                $(this.selectors.stateDisplay).removeClass("hide");

                // Display error message on state field if not selected
                if ($(this.selectors.selectState).prop("selectedIndex") == 0) {
                    $(this.selectors.selectState).removeClass("valid").addClass("input-validation-error");
                    $(this.selectors.errorState).addClass("field-validation-error").text($(this.selectors.selectState).attr("data-val-requiredifequal"));
                }
            }
            else {
                // Remove error message and hide state field
                $(this.selectors.stateDisplay).addClass("hide");
                $(this.selectors.selectState).attr("disabled", true).addClass("valid").removeClass("input-validation-error");
                $(this.selectors.errorState).removeClass("field-validation-error").empty();
            }
        },

        onDocumentCountryChanged: function () {
          this.onDocumentAttribution();

        },

        onDocumentAttribution: function () {

          var selectCountry = $(this.selectors.selectDocumentCountry).find("option:selected"),
            taxNumberAttribution = selectCountry.attr("data-taxnumber-country");

            //recovery of the data tax number
          if ($(this.selectors.professionalContainer).is(':visible')) {

            var taxNumberRegex = selectCountry.attr("data-taxnumber-regex"),
              inputProfessionalDocument = $(this.selectors.professionalContainer).find('.js-form-input'),
              inputFiscalNumber = $(this.selectors.professionalContainer).find('.js-fiscal-number-type');

            switch (taxNumberAttribution) {
              case "ES":
                $('.js-document-label').text('CIF');
                inputFiscalNumber.val("3");
                inputProfessionalDocument.rules("add", { regex: "^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$" });
                break;
              case 'CEE':
                inputProfessionalDocument.rules("add", { regex: "^" + taxNumberRegex });
                $('.js-document-label').text('N° intracomunitario');
                inputFiscalNumber.val("5");
                break;
              default:
                $('.js-document-label').text('N° fiscal');
                inputProfessionalDocument.rules("add", { regex: "^.*" });
                inputFiscalNumber.val("6");
                break;
            }
          } else {

            var isES = taxNumberAttribution == 'ES';

            var options = $("[name=FiscalTaxNumberType]").find("option");

            for (var i = 0; i < options.length; i++) {
              options[i].className = "";
            }

            for (var i = 0; i < options.length; i++) {
              if (isES) {
                if (options[i].text == 'Pasaporte') {
                  options[i].className += "hide";
                }
              } else {
                if (options[i].text == 'NIF' || options[i].text == 'NIE') {
                  options[i].className += "hide";
                }
              }
            }

            if (!isES) {
              $('.js-document-type').attr("value", "1");
              $('.js-document-type').val("1");
              $('.js-document-label').text('Pasaporte');
              this.renderClientTypeChange();
            } else if (isES && $('.js-document-type').attr("value") == "1"){

              $('.js-document-type').attr("value", "2");
              $('.js-document-type').val("2");
              $('.js-document-label').text('NIF');
              this.renderClientTypeChange();
            }
          }
        },

        onBlurDocument: function () {
            $(this.selectors.disabledDocument).find(this.selectors.inputElement).val(function () {
                return this.value.toUpperCase();
            });
        },

        onDisplayClientType: function (e) {
            this.toggleDisplayClient($(e.target));
        },

        onClientTypeChange: function () {
            this.renderClientTypeChange();
        },

        hideStateField: function () {
            if ($(this.selectors.selectState) && $(this.selectors.selectCountry).find(":selected").val() !== "197") {
                $(this.selectors.stateDisplay).addClass("hide");
            }
        }

        //onSubmit: function (e) {

        //    //var allEmpty = !$('.js-form-input-phones :input:text').filter(function () {
        //    //    return $.trim(this.value) != "";
        //    //}).length

        //    //if (allEmpty) {
        //    //    e.preventDefault();
        //    //    e.stopImmediatePropagation();
        //    //    $('.js-form-input-phone').addClass('input-validation-error');
        //    //    $('.js-form-input-cellphone').addClass('input-validation-error');
        //    //    $('.js-phones-error-message').html($('.js-form-input-cellphone').data('val-requiredifnotset'));

        //    //};   

        //}

    })
